var makeRenderlessComponent = function (hook) { return function (props) {
    hook(props);
    return null;
}; };

export { makeRenderlessComponent };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/motion/utils/make-renderless-component.mjs
// module id = bqSq
// module chunks = 0